/** @jsx jsx */
import { jsx } from '@emotion/react'
import { testeArabeStyle } from '../assets/styles/TesteArabe.styles'
import { Col, Container, Row, Button } from 'react-bootstrap'

const TesteArabe = ({ onOpenQuiz }) => {
  return (
    <section css={testeArabeStyle}>
      <Container>
        <Row data-aos="fade-down" data-aos-delay="500" className='title-sec'>
          <Col lg={6} md={6} sm={12} />
          <Col lg={1} md={1} sm={12} />
          <Col lg={5} md={5} sm={12}>
            <h2>Quanto você conhece da cultura árabe?</h2>
            <p>Explore curiosidades, costumes, tradições e aspectos históricos da cultura árabe em um quiz leve e educativo.</p>
            <Button className='' onClick={onOpenQuiz} style={{ marginTop: 24 }}>
              INICIAR TESTE
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default TesteArabe;
